export enum FlowerTypes {
  Both = 'Both',
  Japanese = 'Japanese',
  Western = 'Western',
}
